export const UniqueKeyGenerator = (prefix: string): string => {
	return `${ prefix }_${ new Date().getTime() }`
}